export default "__VITE_ASSET__DBEKi6Xa__"